import { render, staticRenderFns } from "./StatusUpdatePopup.vue?vue&type=template&id=99b19c84"
import script from "./StatusUpdatePopup.vue?vue&type=script&lang=js"
export * from "./StatusUpdatePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports